import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';

import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const token = auth.token();
  const authorized = token
    ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : request;

  return next(authorized).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof Object) || !('status' in error) || error.status !== 401) {
        return throwError(() => error);
      }

      return from(auth.tryRefresh()).pipe(
        switchMap((refreshed) => {
          const freshToken = auth.token();
          if (!refreshed || !freshToken) {
            void auth.logout();
            return throwError(() => error);
          }

          return next(request.clone({ setHeaders: { Authorization: `Bearer ${freshToken}` } }));
        }),
      );
    }),
  );
};
